/*
  CK Store — "Family Pack" page (sections/ck-family-pack.liquid)
  1. number of family members (− / +)
  2. each member: gender, age (→ kids or adult piece, size suggested from the age), size
     (adults: Set or Hoodie when the design has both)
  3. one colour for the whole family
  4. one design for the whole family — designs are grouped by:
       product metafield custom.family_design  →  design code tag (P4, D25…)  →  title without
       "Kids Set / Adult Set / Hoodie"
  → one /cart/add.js request (line property "_family_pack"), then /discount/<CODE>?redirect=/cart
  Desktop: sticky summary panel · phone: bar above the store's bottom menu + summary sheet.
  The pack is kept in sessionStorage so a refresh doesn't lose it.
  Cart sync: packs ALREADY in the cart (/cart.js, line property "_family_pack") are shown at the top
  of the page — "Edit this pack" loads it back into the builder (saving replaces it in the cart),
  "Remove" takes it out, "Build another family pack" opens an empty builder. Kept in sync with the
  theme's "cart:updated" event, the back/forward cache (pageshow) and when the tab comes back.
  The real discount is the Shopify discount code; the numbers here are an estimate.
*/
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('ck-family-pack')) return;

  /* ---------- helpers ---------- */
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  // <bdi> keeps prices, sizes and names reading the right way inside Arabic (RTL) text
  function bdi(str) { return '<bdi>' + esc(str) + '</bdi>'; }
  function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/\s+/g, ' ').trim(); }
  function formatMoney(cents, format) {
    cents = Math.round(cents);
    var fmt = format || '{{amount}}';
    if (cents % 100 === 0) {
      fmt = fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}')
               .replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}');
    }
    function d(n, p, t, dec) {
      var parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return fmt;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      default: v = d(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (val === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  /* ---------- sizes ---------- */
  var ADULT_ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', 'xxxl', '3xl', '4xl', '5xl', '6xl'];
  var MONTH_RE = /(\d+(?:[.,]\d+)?)\s*(?:(?:-|–|to|à|a|إلى|الى)\s*(\d+(?:[.,]\d+)?))?\s*(?:m\b|mo\b|mos\b|months?|mois|شهر|أشهر|اشهر|شهور|شهرا|شهراً)/i;
  var YEAR_RE = /(\d+)\s*(?:(?:-|–|to|à|a|إلى|الى)\s*(\d+))?\s*(?:y\b|yr|yrs|years?|ans?|سنة|سنوات|سنين|عام|أعوام|اعوام)/i;
  // age range of a size label, in years: [min, max)  — "4-5 years" → [4, 6) fits 4 and 5 year olds
  function parseSize(name) {
    var t = String(name || '');
    var m = t.match(MONTH_RE);
    if (m) {
      var a = parseFloat(m[1].replace(',', '.'));
      if (m[2]) return { kid: true, min: a / 12, max: parseFloat(m[2].replace(',', '.')) / 12 };
      return { kid: true, min: Math.max(0, a - 6) / 12, max: (a + 12) / 12 };
    }
    m = t.match(YEAR_RE);
    if (m) {
      var y1 = parseInt(m[1], 10), y2 = m[2] ? parseInt(m[2], 10) : y1;
      return { kid: true, min: y1, max: y2 + 1 };
    }
    var k = norm(t).replace(/\s/g, '');
    return { kid: false, rank: ADULT_ORDER.indexOf(k) > -1 ? ADULT_ORDER.indexOf(k) : 50 };
  }
  function sortSizes(list) {
    return list.slice().sort(function (a, b) {
      if (a.info.kid && b.info.kid) return a.info.min - b.info.min || a.info.max - b.info.max;
      if (!a.info.kid && !b.info.kid) return a.info.rank - b.info.rank;
      return a.info.kid ? -1 : 1;
    });
  }

  /* ---------- design grouping ---------- */
  var KIND_WORDS = /\b(kids?|adults?|bab(?:y|ies)|toddlers?|teens?|set|sets|hoodies?|sweatshirts?|t-?shirts?|tees?|family|men|women|unisex)\b|طقم|أطقم|اطقم|أطفال|اطفال|للأطفال|للاطفال|بالغين|للكبار|كبار|هودي|تي\s?شيرت|تيشيرت/gi;
  function cleanName(title) {
    var t = String(title || '').split(/\s+[–—-]\s*|\s*[–—]\s+|\s*\|\s*/)[0];
    t = t.replace(KIND_WORDS, ' ').replace(/[&+]\s*$/, '').replace(/\s+/g, ' ').trim();
    return t || String(title || '').trim();
  }
  function kindOf(p) {
    var t = (p.type || '') + ' ' + (p.title || '');
    if (/hood|sweat|هودي/i.test(t)) return 'hoodie';
    if (/t-?shirt|\btee\b|تي\s?شيرت|تيشيرت/i.test(t)) return 'tshirt';
    return 'set';
  }
  function designKey(p) {
    if (p.familyDesign) return 'm:' + norm(p.familyDesign);
    var tags = p.tags || [];
    for (var i = 0; i < tags.length; i++) {
      var tg = String(tags[i]).trim();
      if (/^[A-Za-z]{1,3}\d{1,4}$/.test(tg)) return 't:' + tg.toUpperCase();
    }
    return 'n:' + norm(cleanName(p.title));
  }

  var ICON = {
    edit: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    bag: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1 12H6zM9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    up: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg>',
    alert: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5h.01"/></svg>',
    adult: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="5.5" r="2.8"/><path d="M7 21v-7.5A3.5 3.5 0 0 1 10.5 10h3a3.5 3.5 0 0 1 3.5 3.5V21M9.5 21v-5M14.5 21v-5"/></svg>',
    kid: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9" r="2.4"/><path d="M8.5 21v-5a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v5M10.5 21v-3M13.5 21v-3"/></svg>',
    person: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="7" r="3"/><path d="M5.5 20.5a6.5 6.5 0 0 1 13 0"/></svg>',
    male: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="14" r="5"/><path d="M13.5 10.5 19 5M14.5 5H19v4.5"/></svg>',
    female: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9" r="5"/><path d="M12 14v7M9 18h6"/></svg>',
    family: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="6" r="2.3"/><circle cx="17" cy="6" r="2.3"/><circle cx="12" cy="11" r="1.9"/><path d="M3.5 20v-5.5A3.5 3.5 0 0 1 7 11h0a3.5 3.5 0 0 1 2.2.8M20.5 20v-5.5A3.5 3.5 0 0 0 17 11h0a3.5 3.5 0 0 0-2.2.8M9.5 20v-3a2.5 2.5 0 0 1 5 0v3"/></svg>'
  };

  var uidCounter = 0;

  class CKFamilyPack extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.cfg = JSON.parse(this.querySelector('[data-ckfp-config]').textContent);
      } catch (e) { console.error('[ck-family-pack] bad config', e); return; }
      this.s = this.cfg.s || {};
      this.uid = 'ckfp' + (++uidCounter);
      this.adultAge = this.cfg.adultAge || 16;
      this.min = Math.max(1, this.cfg.minMembers || 2);
      this.max = Math.max(this.min, this.cfg.maxMembers || 10);
      this.pctOff = this.cfg.pct || 0;

      this.prepare();

      this.countEl = this.querySelector('[data-ckfp-count]');
      this.membersEl = this.querySelector('[data-ckfp-members]');
      this.colorsEl = this.querySelector('[data-ckfp-colors]');
      this.designsEl = this.querySelector('[data-ckfp-designs]');
      this.trayEl = this.querySelector('[data-ckfp-tray]');
      this.barEl = this.querySelector('[data-ckfp-bar]');
      this.sheetEl = this.querySelector('[data-ckfp-sheet]');
      this.sheetBody = this.querySelector('[data-ckfp-sheet-body]');
      this.toastEl = this.querySelector('[data-ckfp-toast]');
      this.liveEl = this.querySelector('[data-ckfp-live]');

      // the sheet + bar must sit above the theme's fixed bottom menu and chat buttons
      var dir = this.getAttribute('dir') || 'ltr';
      [this.barEl, this.sheetEl, this.toastEl].forEach(function (el) { document.body.appendChild(el); el.setAttribute('dir', dir); });
      this.sheetBody.setAttribute('data-lenis-prevent', '');

      this.incartEl = this.querySelector('[data-ckfp-incart]');
      this.cart = null;
      this.packs = [];
      this.mode = 'build';
      this.editing = null;

      this.restore();
      this.bind();
      this.renderAll();
      this.watchBottom();
      this.watchCart();
    }

    /* ---------- catalogue ---------- */
    prepare() {
      var self = this, byKey = {}, order = [];
      this.adultKinds = {};
      this.byVariant = {};
      this.allProducts = [];
      (this.cfg.products || []).forEach(function (p) {
        if (!p || !p.variants || !p.variants.length || !p.sizePos) return;
        var sizeOpt = p.options[p.sizePos - 1];
        if (!sizeOpt) return;
        p._sizes = sortSizes(sizeOpt.values.map(function (v) { return { name: v.name, info: parseSize(v.name) }; }));
        p._kids = p._sizes.filter(function (z) { return z.info.kid; });
        p._adults = p._sizes.filter(function (z) { return !z.info.kid; });
        if (!p._kids.length && !p._adults.length) return;
        p._kind = kindOf(p);
        p.variants.forEach(function (v) { self.byVariant[v.id] = { p: p, v: v }; });
        if (p._adults.length) self.adultKinds[p._kind] = true;
        var prices = p.variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
        p._min = prices.length ? Math.min.apply(null, prices) : Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
        p._colors = {};
        if (p.colorPos) p.options[p.colorPos - 1].values.forEach(function (v) { p._colors[norm(v.name)] = v; });
        p._colorImages = {};
        Object.keys(p.colorImages || {}).forEach(function (k) { p._colorImages[norm(k)] = p.colorImages[k]; });
        var key = designKey(p);
        if (!byKey[key]) { byKey[key] = { key: key, products: [] }; order.push(key); }
        byKey[key].products.push(p);
        self.allProducts.push(p);
      });

      var colors = {}, colorOrder = [];
      this.designs = order.map(function (k) {
        var d = byKey[k];
        var lead = d.products.find(function (p) { return p._adults.length && p._kind === 'set'; }) ||
          d.products.find(function (p) { return p._adults.length; }) || d.products[0];
        d.lead = lead;
        d.name = cleanName(lead.name && lead.name !== lead.title ? lead.name : lead.title);
        d.kids = d.products.some(function (p) { return p._kids.length; });
        d.adults = d.products.some(function (p) { return p._adults.length; });
        d.min = Math.min.apply(null, d.products.map(function (p) { return p._min; }));
        d.colors = {};
        d.products.forEach(function (p) {
          Object.keys(p._colors).forEach(function (ck) {
            d.colors[ck] = true;
            if (!colors[ck]) { colors[ck] = p._colors[ck]; colorOrder.push(ck); }
          });
        });
        d.colorless = !Object.keys(d.colors).length;
        return d;
      });
      this.byDesign = {};
      this.designs.forEach(function (d) { this.byDesign[d.key] = d; }, this);
      this.colors = colorOrder.map(function (ck) { return { key: ck, name: colors[ck].name, hex: colors[ck].hex, img: colors[ck].img }; });
      this.hasKinds = Object.keys(this.adultKinds).length > 1;
    }

    /* ---------- state ---------- */
    newMember() { return { g: null, age: null, kind: 'set', size: null, auto: false }; }
    restore() {
      var saved = store(this.cfg.storageKey);
      var n = this.cfg.defaultMembers || 4;
      this.members = [];
      this.color = null;
      this.design = null;
      if (saved && saved.members && saved.members.length) {
        var self = this;
        this.members = saved.members.slice(0, this.max).map(function (m) {
          var x = self.newMember();
          if (m.g === 'm' || m.g === 'f') x.g = m.g;
          if (typeof m.age === 'number' && self.ageOptions().some(function (o) { return o.v === m.age; })) x.age = m.age;
          if (m.kind && self.adultKinds[m.kind]) x.kind = m.kind;
          if (m.size) x.size = String(m.size);
          x.auto = !!m.auto;
          return x;
        });
        if (saved.color && this.colors.some(function (c) { return c.key === saved.color; })) this.color = saved.color;
        if (saved.design && this.byDesign[saved.design]) this.design = saved.design;
      }
      var target = this.members.length ? Math.max(this.min, this.members.length) : Math.max(this.min, Math.min(this.max, n));
      while (this.members.length < target) this.members.push(this.newMember());
      if (!this.color && this.colors.length === 1) this.color = this.colors[0].key;
      if (!this.design && this.designs.length === 1) this.design = this.designs[0].key;
      this.members.forEach(function (m) { this.fixSize(m); }, this);
    }
    save() {
      store(this.cfg.storageKey, { members: this.members, color: this.color, design: this.design });
    }
    money(c) { return formatMoney(c, this.cfg.moneyFormat); }

    ageOptions() {
      if (this._ages) return this._ages;
      var s = this.s, list = [{ v: 0.25, label: s.age_0 }, { v: 0.75, label: s.age_1 }, { v: 1, label: s.age_y1 }, { v: 2, label: s.age_y2 }];
      for (var y = 3; y < this.adultAge; y++) list.push({ v: y, label: fill(y > 10 ? s.age_y11 : s.age_y, { n: y }) });
      list.push({ v: this.adultAge, label: fill(s.age_adult, { n: this.adultAge }) });
      this._ages = list;
      return list;
    }
    aud(m) { return m.age == null ? null : (m.age >= this.adultAge ? 'adult' : 'kid'); }
    ageLabel(m) {
      if (m.age == null) return '';
      if (m.age >= this.adultAge) return this.s.adult;
      var o = this.ageOptions().find(function (x) { return x.v === m.age; });
      return o ? o.label : '';
    }
    genderLabel(m, g) {
      var a = this.aud(m), s = this.s;
      g = g || m.g;
      if (!g) return '';
      if (a === 'adult') return g === 'm' ? s.man : s.woman;
      if (a === 'kid') return g === 'm' ? s.boy : s.girl;
      return g === 'm' ? s.male : s.female;
    }
    who(m) {
      return [this.genderLabel(m), this.ageLabel(m)].filter(Boolean).join(' · ');
    }

    /* products / sizes for one member */
    productFor(d, m) {
      var a = this.aud(m);
      if (!d || !a) return null;
      var list = d.products.filter(function (p) { return a === 'kid' ? p._kids.length : p._adults.length; });
      if (!list.length) return null;
      if (a === 'adult') return list.find(function (p) { return p._kind === m.kind; }) || list.find(function (p) { return p._kind === 'set'; }) || list[0];
      return list.find(function (p) { return p._kind === 'set'; }) || list[0];
    }
    sizesFor(m) {
      var a = this.aud(m);
      if (!a) return [];
      var d = this.byDesign[this.design];
      var p = this.productFor(d, m);
      if (p) return a === 'kid' ? p._kids : p._adults;
      // no design yet: every size of that kind of piece in the catalogue
      var seen = {}, out = [];
      this.allProducts.forEach(function (q) {
        if (a === 'adult' && this.hasKinds && q._kind !== m.kind) return;
        (a === 'kid' ? q._kids : q._adults).forEach(function (z) { if (!seen[z.name]) { seen[z.name] = 1; out.push(z); } });
      }, this);
      return sortSizes(out);
    }
    suggest(m, sizes) {
      if (this.aud(m) !== 'kid' || !sizes.length) return null;
      var age = m.age, best = null;
      sizes.forEach(function (z) {
        if (age >= z.info.min && age < z.info.max) {
          if (!best || z.info.min > best.info.min || (z.info.min === best.info.min && z.info.max > best.info.max)) best = z;
        }
      });
      if (!best) best = sizes.find(function (z) { return z.info.min > age; }) || sizes[sizes.length - 1];
      return best ? best.name : null;
    }
    // keep the chosen size valid after an age / design / piece change
    fixSize(m) {
      var sizes = this.sizesFor(m);
      if (!sizes.length) { if (m.age == null) { m.size = null; m.auto = false; } return; }
      var ok = m.size && sizes.some(function (z) { return z.name === m.size; });
      if (this.aud(m) === 'kid' && (m.auto || !ok)) {
        m.size = this.suggest(m, sizes);
        m.auto = true;
      } else if (!ok) {
        m.size = null;
        m.auto = false;
      }
    }
    variantFor(p, colorKey, size) {
      if (!p || !size) return null;
      var hits = p.variants.filter(function (v) {
        if (v.options[p.sizePos - 1] !== size) return false;
        if (p.colorPos && colorKey) return norm(v.options[p.colorPos - 1]) === colorKey;
        return true;
      });
      return hits.find(function (v) { return v.available; }) || hits[0] || null;
    }
    imageFor(p, colorKey) {
      if (!p) return '';
      return (colorKey && p._colorImages[colorKey]) || p.image || '';
    }
    designImage(d) {
      var ck = this.color || Object.keys(d.colors)[0];
      return this.imageFor(d.lead, ck) || d.products.map(function (p) { return p.image; }).find(Boolean) || '';
    }
    sizeAvailable(m, size) {
      var d = this.byDesign[this.design];
      var p = this.productFor(d, m);
      if (!p) return true;
      if (this.color || !p.colorPos) {
        var v = this.variantFor(p, this.color, size);
        return !!(v && v.available);
      }
      return p.variants.some(function (x) { return x.available && x.options[p.sizePos - 1] === size; });
    }
    // can this design dress the whole family (in the chosen colour + sizes)?
    designStatus(d) {
      if (this.color && !d.colorless && !d.colors[this.color]) return 'no_color';
      for (var i = 0; i < this.members.length; i++) {
        var m = this.members[i], a = this.aud(m);
        if (!a) continue;
        if (a === 'kid' && !d.kids) return 'out';
        if (a === 'adult' && !d.adults) return 'out';
        var p = this.productFor(d, m);
        if (!p) return 'out';
        if (!m.size) continue;
        var sizes = a === 'kid' ? p._kids : p._adults;
        if (!sizes.some(function (z) { return z.name === m.size; })) continue; // will be re-suggested
        var v = this.variantFor(p, this.color, m.size);
        if (this.color && p.colorPos) { if (!v || !v.available) return 'out'; }
        else if (!p.variants.some(function (x) { return x.available && x.options[p.sizePos - 1] === m.size; })) return 'out';
      }
      return 'ok';
    }
    lineFor(m) {
      var d = this.byDesign[this.design];
      var p = this.productFor(d, m);
      if (!p || !m.size || !m.g) return null;
      if (p.colorPos && !this.color) return null;
      var v = this.variantFor(p, this.color, m.size);
      if (!v || !v.available) return null;
      return { p: p, v: v };
    }
    memberMissing(m) {
      if (!m.g) return 'g';
      if (m.age == null) return 'a';
      if (!m.size) return 's';
      if (this.design && this.color) {
        var p = this.productFor(this.byDesign[this.design], m);
        var v = this.variantFor(p, this.color, m.size);
        if (!v || !v.available) return 's';
      }
      return null;
    }
    missingList() {
      var out = [];
      this.members.forEach(function (m, i) { var f = this.memberMissing(m); if (f) out.push({ i: i, f: f }); }, this);
      if (this.colors.length && !this.color) out.push({ f: 'color' });
      if (!this.design) out.push({ f: 'design' });
      return out;
    }
    totals() {
      var self = this, sub = 0, done = 0;
      var d = this.byDesign[this.design];
      this.members.forEach(function (m) {
        var l = self.lineFor(m);
        if (l) { sub += l.v.price; done++; }
      });
      var n = this.members.length;
      var pct = n >= this.min ? this.pctOff : 0;
      var disc = Math.round(sub * pct / 100);
      return { sub: sub, disc: disc, total: sub - disc, pct: pct, done: done, n: n, ready: done === n && !!d && (!this.colors.length || !!this.color) };
    }

    /* ---------- events ---------- */
    bind() {
      var self = this;
      function onChange(e) {
        var t = e.target, f = t.getAttribute('data-f');
        if (!f) return;
        var i = parseInt(t.getAttribute('data-i'), 10);
        var m = self.members[i];
        if (f === 'g' && m) { m.g = t.value; self.memberChanged(i); }
        else if (f === 'a' && m) {
          m.age = t.value === '' ? null : parseFloat(t.value);
          if (self.aud(m) !== 'kid') m.auto = false;
          self.fixSize(m); self.memberChanged(i);
        }
        else if (f === 'k' && m) { m.kind = t.value; self.fixSize(m); self.memberChanged(i); }
        else if (f === 's' && m) { m.size = t.value; m.auto = false; self.memberChanged(i); }
        else if (f === 'color') { self.color = t.value; self.members.forEach(function (x) { self.fixSize(x); }); self.changed(true); }
        else if (f === 'design') { self.design = t.value; self.members.forEach(function (x) { self.fixSize(x); }); self.changed(true); }
      }
      function onClick(e) {
        var t;
        if ((t = e.target.closest('[data-ckfp-step]'))) { self.setCount(self.members.length + parseInt(t.getAttribute('data-ckfp-step'), 10)); return; }
        if ((t = e.target.closest('[data-ckfp-goto]'))) { self.closeSheet(true); self.focusField(t.getAttribute('data-ckfp-goto')); return; }
        if (e.target.closest('[data-ckfp-close]')) { self.closeSheet(); return; }
        if ((t = e.target.closest('[data-ckfp-view]'))) { self.openSheet(t); return; }
        if ((t = e.target.closest('[data-ckfp-add]'))) { self.addToCart(t); return; }
        if ((t = e.target.closest('[data-ckfp-edit]'))) { self.editPack(t.getAttribute('data-ckfp-edit')); return; }
        if ((t = e.target.closest('[data-ckfp-remove]'))) { self.removePack(t.getAttribute('data-ckfp-remove'), t); return; }
        if (e.target.closest('[data-ckfp-new]')) { self.startNew(); return; }
        if (e.target.closest('[data-ckfp-cancel-edit]')) { self.cancelEdit(); }
      }
      this.addEventListener('change', onChange);
      this.addEventListener('click', onClick);
      this.sheetEl.addEventListener('click', onClick);
      this.barEl.addEventListener('click', onClick);
      document.addEventListener('keydown', function (e) {
        if (!self.sheetOpen) return;
        if (e.key === 'Escape') { self.closeSheet(); return; }
        if (e.key === 'Tab') self.trapFocus(e);
      });
    }
    setCount(n) {
      n = Math.max(this.min, Math.min(this.max, n));
      if (n === this.members.length) return;
      while (this.members.length < n) this.members.push(this.newMember());
      if (this.members.length > n) this.members = this.members.slice(0, n);
      this.save();
      this.renderCount(true);
      this.renderMembers();
      this.renderDesignState();
      this.renderSummary();
      this.announce(fill(this.s.count_live, { n: n }));
    }
    memberChanged(i) {
      this.save();
      this.renderMember(i);
      this.renderCount(true);
      this.renderDesignState();
      this.renderSummary();
    }
    changed() {
      this.save();
      this.renderColors(true);
      this.members.forEach(function (m, i) { this.renderMember(i); }, this);
      this.renderDesignState();
      this.renderSummary();
    }
    announce(text) {
      var el = this.liveEl;
      el.textContent = '';
      setTimeout(function () { el.textContent = text; }, 30);
    }

    /* ---------- render ---------- */
    renderAll() {
      this.renderCount();
      this.renderMembers();
      this.renderColors();
      this.renderDesigns();
      this.renderSummary();
    }
    withFocus(fn) {
      var a = document.activeElement, id = a && a.id && this.contains(a) ? a.id : null;
      fn();
      if (id) {
        var el = document.getElementById(id);
        if (el && el !== document.activeElement) el.focus({ preventScroll: true });
      }
    }
    renderCount(patch) {
      var s = this.s, n = this.members.length, self = this;
      var people = this.members.map(function (m) {
        var a = self.aud(m);
        return '<span class="ckfp-count__p' + (a === 'kid' ? ' is-kid' : '') + (a ? ' is-set' : '') + '">' + (a === 'kid' ? ICON.kid : ICON.adult) + '</span>';
      }).join('');
      if (patch && this.countEl.firstChild) {
        this.countEl.querySelector('output').textContent = n;
        this.countEl.querySelector('.ckfp-count__people').innerHTML = people;
        this.countEl.querySelector('[data-ckfp-step="-1"]').disabled = n <= this.min;
        this.countEl.querySelector('[data-ckfp-step="1"]').disabled = n >= this.max;
        return;
      }
      this.countEl.innerHTML =
        '<div class="ckfp-count__box" role="group" aria-label="' + esc(s.count_label) + '">' +
          '<button type="button" class="ckfp-count__btn" data-ckfp-step="-1" aria-label="' + esc(s.dec) + '"' + (n <= this.min ? ' disabled' : '') + '>' + ICON.minus + '</button>' +
          '<span class="ckfp-count__val"><output aria-hidden="true">' + n + '</output><small aria-hidden="true">' + esc(fill(s.members_n, { n: '' }).trim()) + '</small></span>' +
          '<button type="button" class="ckfp-count__btn" data-ckfp-step="1" aria-label="' + esc(s.inc) + '"' + (n >= this.max ? ' disabled' : '') + '>' + ICON.plus + '</button>' +
        '</div>' +
        '<div class="ckfp-count__people" aria-hidden="true">' + people + '</div>';
    }
    renderMembers() {
      var html = '';
      for (var i = 0; i < this.members.length; i++) html += this.memberHTML(i);
      this.withFocus(function () { this.membersEl.innerHTML = html; }.bind(this));
    }
    // Update one member card IN PLACE: only the parts whose HTML changed are swapped, and the
    // age <select> itself is never replaced or re-focused. (Replacing it right after a choice made
    // iPhones re-open the picker, so the age had to be chosen twice.)
    renderMember(i) {
      var card = this.membersEl.querySelector('[data-ckfp-member="' + i + '"]');
      if (!card) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = this.memberHTML(i);
      var fresh = tmp.firstChild, m = this.members[i];
      card.className = fresh.className;
      this.withFocus(function () {
        ['head', 'g', 'k', 's', 'ae'].forEach(function (part) {
          var o = card.querySelector('[data-part="' + part + '"]'), n = fresh.querySelector('[data-part="' + part + '"]');
          if (o && n && o.outerHTML !== n.outerHTML) o.replaceWith(n);
        });
      });
      var oa = card.querySelector('[data-part="a"]'), na = fresh.querySelector('[data-part="a"]');
      if (oa && na) {
        oa.className = na.className;
        var sel = oa.querySelector('select'), nsel = na.querySelector('select');
        ['aria-invalid', 'aria-describedby'].forEach(function (at) {
          if (nsel.hasAttribute(at)) sel.setAttribute(at, nsel.getAttribute(at)); else sel.removeAttribute(at);
        });
        var want = m.age == null ? '' : String(m.age);
        if (sel.value !== want) sel.value = want;
      }
    }
    fieldErr(id, show, text) {
      return show ? '<p class="ckfp-err" id="' + id + '">' + ICON.alert + '<span>' + esc(text) + '</span></p>' : '';
    }
    memberHTML(i) {
      var self = this, s = this.s, m = this.members[i], id = this.uid + '-m' + i;
      var a = this.aud(m), missing = this.memberMissing(m), err = this.showErrors;
      var title = fill(s.member, { n: i + 1 });
      var whoTxt = this.who(m);

      var gHTML = ['m', 'f'].map(function (g) {
        var gid = id + '-g-' + g;
        return '<label class="ckfp-chip ckfp-chip--g" for="' + gid + '">' +
          '<input type="radio" id="' + gid + '" name="' + id + '-g" value="' + g + '" data-f="g" data-i="' + i + '"' + (m.g === g ? ' checked' : '') + '>' +
          '<span>' + (g === 'm' ? ICON.male : ICON.female) + esc(self.genderLabel(m, g)) + '</span></label>';
      }).join('');
      var gErr = err && missing === 'g';

      var ages = this.ageOptions().map(function (o) {
        return '<option value="' + o.v + '"' + (m.age === o.v ? ' selected' : '') + '>' + esc(o.label) + '</option>';
      }).join('');
      var aErr = err && missing === 'a';

      var kHTML = '';
      if (a === 'adult' && this.hasKinds) {
        var d = this.byDesign[this.design];
        var kinds = ['set', 'hoodie', 'tshirt'].filter(function (k) {
          if (!self.adultKinds[k]) return false;
          return !d || d.products.some(function (p) { return p._adults.length && p._kind === k; });
        });
        if (kinds.length > 1) {
          kHTML = '<fieldset class="ckfp-field"><legend class="ckfp-field__label">' + esc(s.piece) + '</legend><div class="ckfp-opts ckfp-opts--2">' +
            kinds.map(function (k) {
              var kid = id + '-k-' + k;
              return '<label class="ckfp-chip" for="' + kid + '"><input type="radio" id="' + kid + '" name="' + id + '-k" value="' + k + '" data-f="k" data-i="' + i + '"' + (m.kind === k ? ' checked' : '') + '><span>' + esc(s['kind_' + k]) + '</span></label>';
            }).join('') + '</div></fieldset>';
        }
      }

      var sizes = this.sizesFor(m);
      var sErr = err && missing === 's';
      var sizeHTML;
      if (!a) {
        sizeHTML = '<p class="ckfp-field__hint">' + esc(s.size_first) + '</p>';
      } else {
        var sugg = a === 'kid' ? this.suggest(m, sizes) : null;
        sizeHTML = '<div class="ckfp-opts ckfp-opts--sizes">' + sizes.map(function (z, zi) {
          var zid = id + '-s-' + zi;
          var ok = self.sizeAvailable(m, z.name);
          return '<label class="ckfp-chip ckfp-chip--size' + (ok ? '' : ' is-out') + '" for="' + zid + '">' +
            '<input type="radio" id="' + zid + '" name="' + id + '-s" value="' + esc(z.name) + '" data-f="s" data-i="' + i + '"' +
              (m.size === z.name ? ' checked' : '') + (ok ? '' : ' disabled') + (sErr ? ' aria-describedby="' + id + '-se"' : '') + '>' +
            '<span>' + bdi(z.name) + (ok ? '' : '<small>' + esc(s.sold_out) + '</small>') + (sugg === z.name ? '<i class="ckfp-chip__dot" aria-hidden="true"></i>' : '') + '</span></label>';
        }).join('') + '</div>' +
        (sugg ? '<p class="ckfp-field__hint"><i class="ckfp-chip__dot" aria-hidden="true"></i>' + bdi(sugg) + ' — ' + esc(s.size_hint) + '</p>' : '');
      }

      var line = this.lineFor(m);
      var status = missing ? '<span class="ckfp-mem__status">' + esc(s.todo) + '</span>'
        : '<span class="ckfp-mem__status is-ok">' + ICON.check + esc(s.ready) + '</span>';

      return '<article class="ckfp-mem' + (missing ? '' : ' is-ok') + (err && missing ? ' has-err' : '') + '" data-ckfp-member="' + i + '" aria-labelledby="' + id + '-t">' +
        '<header class="ckfp-mem__head" data-part="head">' +
          '<span class="ckfp-mem__avatar' + (a === 'kid' ? ' is-kid' : '') + '" aria-hidden="true">' + (a === 'kid' ? ICON.kid : a ? ICON.adult : ICON.person) + '</span>' +
          '<div class="ckfp-mem__title"><h3 id="' + id + '-t">' + esc(title) + '</h3>' + (whoTxt ? '<p>' + esc(whoTxt) + (line ? ' · ' + bdi(this.money(line.v.price)) : '') + '</p>' : '') + '</div>' +
          status +
        '</header>' +
        '<fieldset class="ckfp-field' + (gErr ? ' is-err' : '') + '" data-part="g"' + (gErr ? ' aria-describedby="' + id + '-ge"' : '') + '>' +
          '<legend class="ckfp-field__label">' + esc(s.gender) + '</legend>' +
          '<div class="ckfp-opts ckfp-opts--2">' + gHTML + '</div>' + this.fieldErr(id + '-ge', gErr, s.need_gender) +
        '</fieldset>' +
        '<div class="ckfp-field' + (aErr ? ' is-err' : '') + '" data-part="a">' +
          '<label class="ckfp-field__label" for="' + id + '-a">' + esc(s.age) + '</label>' +
          '<div class="ckfp-select"><select id="' + id + '-a" data-f="a" data-i="' + i + '"' + (aErr ? ' aria-invalid="true" aria-describedby="' + id + '-ae"' : '') + '>' +
            '<option value="">' + esc(s.age_pick) + '</option>' + ages + '</select></div>' +
          '<div data-part="ae">' + this.fieldErr(id + '-ae', aErr, s.need_age) + '</div>' +
        '</div>' +
        '<div data-part="k">' + kHTML + '</div>' +
        '<fieldset class="ckfp-field' + (sErr ? ' is-err' : '') + '" data-part="s">' +
          '<legend class="ckfp-field__label">' + esc(s.size) + (m.size ? ': <strong>' + bdi(m.size) + '</strong>' : '') + '</legend>' +
          sizeHTML + this.fieldErr(id + '-se', sErr, s.need_size) +
        '</fieldset>' +
      '</article>';
    }
    renderColors(patch) {
      var s = this.s, self = this, id = this.uid + '-c';
      if (!this.colors.length) { this.colorsEl.closest('.ckfp-step').hidden = true; return; }
      var cErr = this.showErrors && !this.color;
      if (patch && this.colorsEl.firstChild) {
        this.colorsEl.querySelector('.ckfp-field').classList.toggle('is-err', cErr);
        var e1 = this.colorsEl.querySelector('.ckfp-err');
        if (e1) e1.remove();
        if (cErr) this.colorsEl.querySelector('.ckfp-field').insertAdjacentHTML('beforeend', this.fieldErr(id + '-err', true, s.need_color));
        var lbl = this.colorsEl.querySelector('.ckfp-field__label strong');
        var c = this.colors.find(function (x) { return x.key === self.color; });
        if (lbl) lbl.textContent = c ? c.name : '';
        return;
      }
      this.colorsEl.innerHTML =
        '<fieldset class="ckfp-field' + (cErr ? ' is-err' : '') + '">' +
          '<legend class="ckfp-field__label">' + esc(s.colour_note) + ' <strong>' + esc((this.colors.find(function (x) { return x.key === self.color; }) || {}).name || '') + '</strong></legend>' +
          '<div class="ckfp-colors">' + this.colors.map(function (c, ci) {
            var cid = id + '-' + ci;
            var bg = c.img ? 'background-image:url(' + esc(c.img) + ')' : (c.hex ? 'background:' + esc(c.hex) : 'background:#ccc');
            return '<label class="ckfp-sw" for="' + cid + '"><input type="radio" id="' + cid + '" name="' + id + '" value="' + esc(c.key) + '" data-f="color"' + (self.color === c.key ? ' checked' : '') + '>' +
              '<span class="ckfp-sw__dot" style="' + bg + '"></span><span class="ckfp-sw__name">' + bdi(c.name) + '</span></label>';
          }).join('') + '</div>' + this.fieldErr(id + '-err', cErr, s.need_color) +
        '</fieldset>';
    }
    renderDesigns() {
      var s = this.s, self = this, id = this.uid + '-d';
      if (!this.designs.length) { this.designsEl.innerHTML = '<p class="ckfp-field__hint">' + esc(s.empty) + '</p>'; return; }
      this.designsEl.innerHTML =
        '<fieldset class="ckfp-field">' +
          '<legend class="ckfp-field__label">' + esc(s.design_note) + '</legend>' +
          '<div class="ckfp-designs">' + this.designs.map(function (d, di) {
            var did = id + '-' + di;
            return '<label class="ckfp-design" for="' + did + '" data-ckfp-design="' + esc(d.key) + '">' +
              '<input type="radio" id="' + did + '" name="' + id + '" value="' + esc(d.key) + '" data-f="design" aria-describedby="' + did + '-st">' +
              '<span class="ckfp-design__media"><img src="' + esc(self.designImage(d)) + '" alt="" loading="lazy" width="480" height="480"></span>' +
              '<span class="ckfp-design__check" aria-hidden="true">' + ICON.check + '</span>' +
              '<span class="ckfp-design__info"><span class="ckfp-design__name">' + bdi(d.name) + '</span>' +
                '<span class="ckfp-design__price" id="' + did + '-st"></span></span>' +
            '</label>';
          }).join('') + '</div>' +
          '<div data-ckfp-design-err></div>' +
        '</fieldset>';
      this.renderDesignState();
    }
    renderDesignState() {
      var s = this.s, self = this;
      var cards = this.designsEl.querySelectorAll('[data-ckfp-design]');
      var allSet = this.members.every(function (m) { return self.aud(m); });
      Array.prototype.forEach.call(cards, function (card) {
        var d = self.byDesign[card.getAttribute('data-ckfp-design')];
        if (!d) return;
        var st = self.designStatus(d);
        var input = card.querySelector('input');
        var on = self.design === d.key;
        input.checked = on;
        input.disabled = st !== 'ok' && !on;
        card.classList.toggle('is-on', on);
        card.classList.toggle('is-out', st !== 'ok');
        var img = card.querySelector('img'), src = self.designImage(d);
        if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
        var price = card.querySelector('.ckfp-design__price');
        var txt;
        if (st === 'no_color') txt = '<em>' + esc(s.design_no_color) + '</em>';
        else if (st === 'out') txt = '<em>' + esc(s.design_out) + '</em>';
        else if (allSet) {
          var sum = self.members.reduce(function (n, m) {
            var p = self.productFor(d, m);
            var v = p && m.size ? self.variantFor(p, self.color, m.size) : null;
            return n + (v ? v.price : (p ? p._min : 0));
          }, 0);
          var pct = self.members.length >= self.min ? self.pctOff : 0;
          var after = Math.round(sum * (100 - pct) / 100);
          txt = (pct ? '<s>' + bdi(self.money(sum)) + '</s> ' : '') + '<b>' + fill(esc(s.family_total), { price: bdi(self.money(after)) }) + '</b>';
        } else txt = fill(esc(s.from), { price: bdi(self.money(d.min)) });
        price.innerHTML = txt;
      });
      var errBox = this.designsEl.querySelector('[data-ckfp-design-err]');
      if (errBox) errBox.innerHTML = this.fieldErr(this.uid + '-d-err', this.showErrors && !this.design, s.need_design);
    }

    /* ---------- summary: side panel (desktop) + bar & sheet (phone) ---------- */
    linesHTML() {
      var self = this, s = this.s, d = this.byDesign[this.design];
      return '<ul class="ckfp-lines" role="list">' + this.members.map(function (m, i) {
        var l = self.lineFor(m);
        var p = l ? l.p : self.productFor(d, m);
        var img = p ? self.imageFor(p, self.color) : '';
        var who = self.who(m);
        return '<li class="' + (l ? 'is-ok' : 'is-todo') + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="96" height="96">' : '<span class="ckfp-lines__ph" aria-hidden="true">' + (self.aud(m) === 'kid' ? ICON.kid : ICON.adult) + '</span>') +
          '<div class="ckfp-lines__txt"><strong>' + esc(fill(s.member, { n: i + 1 })) + (who ? ' · ' + esc(who) : '') + '</strong>' +
            (l ? '<span>' + [s['kind_' + l.p._kind] || '', m.size].filter(Boolean).map(bdi).join(' · ') + '</span>' : '<button type="button" class="ckfp-lines__edit" data-ckfp-goto="' + i + '">' + esc(s.todo) + '</button>') + '</div>' +
          (l ? '<em>' + bdi(self.money(l.v.price)) + '</em>' : '') +
        '</li>';
      }).join('') + '</ul>';
    }
    sumHTML(t) {
      var s = this.s;
      return '<dl class="ckfp-sum">' +
        '<div><dt>' + esc(s.subtotal) + '</dt><dd>' + bdi(this.money(t.sub)) + '</dd></div>' +
        (t.pct ? '<div class="is-save"><dt>' + esc(fill(s.discount, { pct: t.pct })) + '</dt><dd>' + bdi('−' + this.money(t.disc)) + '</dd></div>' : '') +
        '<div class="is-total"><dt>' + esc(s.total) + '</dt><dd>' + (t.disc ? '<s>' + bdi(this.money(t.sub)) + '</s>' : '') + bdi(this.money(t.total)) + '</dd></div>' +
      '</dl>' +
      (t.disc && t.ready ? '<p class="ckfp-saved">' + ICON.check + fill(esc(s.you_save), { amount: bdi(this.money(t.disc)) }) + '</p>' : '');
    }
    packHTML(where) {
      var s = this.s, t = this.totals(), d = this.byDesign[this.design];
      var c = this.colors.find(function (x) { return x.key === this.color; }, this);
      var left = this.missingList().length;
      return '<div class="ckfp-pack__head">' + ICON.family + '<h2>' + esc(s.your_pack) + '</h2><span>' + esc(fill(s.ready_n, { done: t.done, total: t.n })) + '</span></div>' +
        '<div class="ckfp-pack__body">' +
          '<div class="ckfp-pack__meta">' +
            '<p><span>' + esc(s.design) + '</span><strong>' + (d ? esc(d.name) : '<button type="button" class="ckfp-lines__edit" data-ckfp-goto="design">' + esc(s.need_design) + '</button>') + '</strong></p>' +
            (this.colors.length ? '<p><span>' + esc(s.colour) + '</span><strong>' + (c ? '<i class="ckfp-pack__dot" style="' + (c.hex ? 'background:' + esc(c.hex) : '') + '"></i>' + bdi(c.name) : '<button type="button" class="ckfp-lines__edit" data-ckfp-goto="color">' + esc(s.need_color) + '</button>') + '</strong></p>' : '') +
          '</div>' +
          this.linesHTML() +
          this.sumHTML(t) +
          (this.error ? '<p class="ckfp-error" role="alert">' + esc(this.error) + '</p>' : '') +
          '<button type="button" class="ckfp-cta" data-ckfp-add' + (this.busy ? ' disabled' : '') + ' aria-describedby="' + this.uid + '-' + where + '-left">' + ICON.bag + '<span>' + esc(this.busy ? s.adding : (this.editing ? s.update : s.add)) + '</span></button>' +
          '<p class="ckfp-note" id="' + this.uid + '-' + where + '-left">' + (left ? esc(fill(s.missing, { n: left })) : ICON.check + esc(fill(s.note, { pct: this.pctOff }))) + '</p>' +
        '</div>';
    }
    renderSummary() {
      var s = this.s, t = this.totals();
      if (this.mode === 'cart') { this.renderCartBar(); return; }
      this.trayEl.innerHTML = this.packHTML('tray');
      if (this.sheetOpen) this.withFocus(function () { this.renderSheet(); }.bind(this));

      var self = this;
      var pics = this.members.map(function (m) { var l = self.lineFor(m); return l ? self.imageFor(l.p, self.color) : ''; }).filter(Boolean);
      var thumbs = pics.slice(0, 3).map(function (src) { return '<img src="' + esc(src) + '" alt="" width="40" height="40">'; }).join('');
      this.barEl.innerHTML =
        '<div class="ckfp-bar__row">' +
          '<button type="button" class="ckfp-bar__info" data-ckfp-view aria-label="' + esc(s.view) + '">' +
            '<span class="ckfp-bar__thumbs">' + (thumbs || '<i>' + ICON.family + '</i>') + '<b>' + t.n + '</b></span>' +
            '<span class="ckfp-bar__txt"><strong>' + (t.sub ? bdi(this.money(t.total)) : bdi('−' + this.pctOff + '%')) + '</strong>' +
              (t.disc ? '<s>' + bdi(this.money(t.sub)) + '</s>' : '<small>' + esc(fill(s.ready_n, { done: t.done, total: t.n })) + '</small>') + '</span>' +
          '</button>' +
          '<button type="button" class="ckfp-bar__btn" data-ckfp-view>' + esc(t.ready ? s.view : s.complete) + ICON.up + '</button>' +
        '</div>';
      this.measureBar();
    }
    renderSheet() {
      var s = this.s;
      this.sheetBody.setAttribute('aria-label', s.your_pack);
      this.sheetBody.innerHTML =
        '<span class="ckfp-sheet__grip" aria-hidden="true"></span>' +
        '<button type="button" class="ckfp-sheet__x" data-ckfp-close aria-label="' + esc(s.close) + '">' + ICON.close + '</button>' +
        '<div class="ckfp-sheet__scroll">' + this.packHTML('sheet') + '</div>';
    }
    openSheet(opener) {
      this.renderSheet();
      var el = this.sheetEl;
      this.opener = opener || document.activeElement;
      this.sheetOpen = true;
      el.hidden = false;
      document.documentElement.classList.add('ckfp-lock');
      requestAnimationFrame(function () { el.classList.add('is-open'); el.querySelector('[role="dialog"]').focus({ preventScroll: true }); });
    }
    closeSheet(noFocus) {
      var el = this.sheetEl;
      if (!this.sheetOpen) return;
      this.sheetOpen = false;
      el.classList.remove('is-open');
      document.documentElement.classList.remove('ckfp-lock');
      setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 260);
      if (!noFocus && this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
    }
    trapFocus(e) {
      var list = Array.prototype.filter.call(this.sheetBody.querySelectorAll('button, a[href], input, select, [tabindex]:not([tabindex="-1"])'), function (x) { return !x.disabled && x.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.sheetBody)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------- validation + add to cart ---------- */
    focusField(target) {
      var el = null, id = this.uid;
      if (target === 'color') el = this.colorsEl.querySelector('input:checked') || this.colorsEl.querySelector('input');
      else if (target === 'design') el = this.designsEl.querySelector('input:checked') || this.designsEl.querySelector('input:not([disabled])');
      else {
        var i = parseInt(target, 10), m = this.members[i];
        if (!m) return;
        var f = this.memberMissing(m) || 'g';
        if (f === 'g') el = document.getElementById(id + '-m' + i + '-g-m');
        else if (f === 'a') el = this.membersEl.querySelector('[data-ckfp-member="' + i + '"] h3');
        else el = this.membersEl.querySelector('[data-ckfp-member="' + i + '"] input[data-f="s"]:checked') ||
          this.membersEl.querySelector('[data-ckfp-member="' + i + '"] input[data-f="s"]:not([disabled])');
        if (!el) el = this.membersEl.querySelector('[data-ckfp-member="' + i + '"] h3');
      }
      if (!el) return;
      var box = el.closest('.ckfp-mem, .ckfp-field') || el;
      var top = box.getBoundingClientRect().top + window.pageYOffset - this.headerOffset();
      if (window.ckLenis && window.ckLenis.scrollTo) window.ckLenis.scrollTo(top, { immediate: true });
      else window.scrollTo({ top: top, behavior: 'smooth' });
      if (el.tagName === 'H3') { el.setAttribute('tabindex', '-1'); }
      setTimeout(function () { el.focus({ preventScroll: true }); }, 60);
    }
    headerOffset() {
      var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--height-header')) || 0;
      var hd = document.querySelector('[data-section-type="header"], .header');
      if (!h && hd) h = hd.getBoundingClientRect().height;
      return Math.min(h, 140) + 16;
    }
    addToCart(btn) {
      if (this.busy) return;
      var s = this.s, missing = this.missingList();
      if (missing.length) {
        this.showErrors = true;
        this.error = '';
        this.members.forEach(function (m, i) { this.renderMember(i); }, this);
        this.renderColors(true);
        this.renderDesignState();
        this.renderSummary();
        this.toast(fill(s.missing, { n: missing.length }));
        var first = missing[0];
        this.closeSheet(true);
        this.focusField(first.f === 'color' || first.f === 'design' ? first.f : String(first.i));
        return;
      }
      var self = this, d = this.byDesign[this.design];
      var packId = 'F' + Date.now().toString(36).toUpperCase();
      var items = this.members.map(function (m, i) {
        var l = self.lineFor(m), props = {};
        props[s.prop_name] = fill(s.prop_member, { n: i + 1, who: self.who(m) });
        props._family_pack = packId;
        props._family_design = d.name;
        props._family_pct = String(self.pctOff);
        props._family_min = String(self.min);
        props._fm_g = m.g;
        props._fm_age = String(m.age);
        if (self.cfg.applyCode && self.cfg.code) props._family_code = self.cfg.code;
        return { id: l.v.id, quantity: 1, properties: props };
      });
      this.busy = true;
      this.error = '';
      this.renderSummary();
      // editing a pack that is in the cart: take the old pieces out first, then add the new ones
      var editId = this.editing && this.editing.id;
      var before = editId ? this.loadCart().then(function () {
        // fresh line keys of that pack (the cart may have changed in another tab)
        var pk = self.packs.find(function (p) { return p.id === editId; });
        return pk ? self.updateCart(pk.lines.map(function (it) { return it.key; })) : null;
      }) : Promise.resolve();
      before.then(function () {
        return fetch(self.cfg.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }).then(function (r) {
        return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || ''); return data; });
      }).then(function () {
        store(self.cfg.storageKey, null);
        store(self.cfg.storageKey + ':edit', null);
        document.dispatchEvent(new CustomEvent('ck:family-pack-added', { bubbles: true, detail: { pack: packId } }));
        var cart = self.cfg.cartUrl;
        var url = self.cfg.applyCode && self.cfg.code
          ? self.cfg.discountUrl + encodeURIComponent(self.cfg.code) + '?redirect=' + encodeURIComponent(cart)
          : cart;
        window.location.href = url;
      }).catch(function (err) {
        self.busy = false;
        self.error = err && err.message ? err.message : s.error;
        self.renderSummary();
        if (!self.sheetOpen && window.matchMedia('(max-width: 989px)').matches) self.openSheet(btn);
      });
    }
    /* ---------- cart sync: family packs already in the cart ---------- */
    watchCart() {
      var self = this;
      var saved = store(this.cfg.storageKey + ':edit');
      if (saved && saved.id) this.editing = saved;
      this.loadCart();
      document.addEventListener('cart:updated', function (e) {
        if (self._ownUpdate) return;
        var c = e && e.detail && e.detail.cart;
        if (c && c.items) self.setCart(c); else self.loadCart();
      });
      document.addEventListener('apps:product-added-to-cart', function () { if (!self._ownUpdate) self.loadCart(); });
      // back / forward from the cart page (iPhone keeps the old page in memory)
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.loadCart(); });
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') self.loadCart(); });
    }
    loadCart() {
      var self = this;
      return fetch(this.cfg.cartJsUrl || (this.cfg.cartUrl + '.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.setCart(c); return c; })
        .catch(function () {});
    }
    setCart(c) {
      this.cart = c;
      var map = {}, list = [];
      (c.items || []).forEach(function (it) {
        var id = it.properties && it.properties._family_pack;
        if (!id) return;
        if (!map[id]) { map[id] = { id: id, lines: [], pieces: 0, sub: 0, design: it.properties._family_design || '', pct: it.properties._family_pct || '', min: parseInt(it.properties._family_min, 10) || 0 }; list.push(map[id]); }
        map[id].lines.push(it);
        map[id].pieces += it.quantity;
        map[id].sub += it.original_line_price != null ? it.original_line_price : it.line_price;
      });
      this.packs = list;
      if (this.editing && !map[this.editing.id]) this.setEditing(null);
      if (!list.length) this.mode = 'build';
      else if (!this._userChoseMode) this.mode = this.editing ? 'build' : 'cart';
      this.renderMode();
    }
    familyDiscount() {
      var c = this.cart || {}, name = String(this.cfg.discountName || '').toLowerCase().trim(), out = null;
      var apps = (c.cart_level_discount_applications || []).slice();
      (c.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application) apps.push(a.discount_application); }); });
      apps.forEach(function (d) {
        var t = String(d.title || '').toLowerCase().trim();
        if ((name && t.indexOf(name) > -1) || /famil|عائل/i.test(t)) out = { pct: d.value_type === 'percentage' && d.value ? String(parseFloat(d.value)) : '' };
      });
      return out;
    }
    setEditing(ed) {
      this.editing = ed;
      store(this.cfg.storageKey + ':edit', ed);
    }
    renderMode() {
      var s = this.s, self = this;
      this.classList.toggle('ckfp--incart', this.mode === 'cart');
      var el = this.incartEl;
      if (this.mode === 'build' && this.editing) {
        el.hidden = false;
        el.innerHTML = '<div class="ckfp-editing" role="status">' + ICON.edit + '<p>' + esc(s.editing) + '</p>' +
          '<button type="button" class="ckfp-btn ckfp-btn--ghost" data-ckfp-cancel-edit>' + esc(s.cancel_edit) + '</button></div>';
      } else if (this.mode === 'cart' && this.packs.length) {
        var disc = this.familyDiscount();
        var n = this.packs.length;
        el.hidden = false;
        el.innerHTML =
          '<section class="ckfp-incart" aria-labelledby="' + this.uid + '-ic">' +
            '<header class="ckfp-incart__head">' +
              '<span class="ckfp-incart__icon" aria-hidden="true">' + ICON.check + '</span>' +
              '<div><h2 id="' + this.uid + '-ic">' + esc(n > 1 ? fill(s.incart_title_n, { n: n }) : s.incart_title) + '</h2><p>' + esc(s.incart_sub) + '</p></div>' +
            '</header>' +
            this.packs.map(function (pk, pi) { return self.cartPackHTML(pk, pi, disc); }).join('') +
            '<div class="ckfp-incart__actions">' +
              '<a class="ckfp-cta ckfp-cta--link" href="' + esc(this.cfg.cartUrl) + '">' + ICON.bag + '<span>' + esc(s.go_cart) + '</span></a>' +
              '<button type="button" class="ckfp-btn ckfp-btn--ghost" data-ckfp-new>' + ICON.plus + '<span>' + esc(s.build_new) + '</span></button>' +
            '</div>' +
          '</section>';
      } else {
        el.hidden = true;
        el.innerHTML = '';
      }
      this.renderSummary();
    }
    cartPackHTML(pk, pi, disc) {
      var s = this.s, self = this;
      var pct = (disc && disc.pct) || pk.pct || String(this.pctOff);
      var min = pk.min || this.min;
      var status;
      if (disc) status = '<p class="ckfp-incart__status is-ok">' + ICON.check + '<span>' + esc(fill(s.fp_applied, { pct: pct })) + '</span></p>';
      else if (pk.pieces < min) {
        var left = min - pk.pieces;
        status = '<p class="ckfp-incart__status is-warn">' + ICON.alert + '<span>' + esc(fill(s.fp_need, { n: left === 1 ? s.fp_one : fill(s.fp_many, { n: left }), pct: pct })) + '</span></p>';
      } else status = '<p class="ckfp-incart__status">' + ICON.check + '<span>' + esc(fill(s.fp_checkout, { pct: pct })) + '</span></p>';
      var lines = pk.lines.map(function (it) {
        var label = '';
        Object.keys(it.properties || {}).forEach(function (k) { if (k.charAt(0) !== '_' && !label) label = it.properties[k]; });
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
        var meta = it.variant_title && !/default title/i.test(it.variant_title) ? it.variant_title : '';
        var price = it.original_line_price != null ? it.original_line_price : it.line_price;
        return '<li>' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="46" height="46">' : '<span class="ckfp-lines__ph" aria-hidden="true">' + ICON.person + '</span>') +
          '<div class="ckfp-lines__txt"><strong>' + esc(label || it.product_title) + (it.quantity > 1 ? ' ×' + it.quantity : '') + '</strong><span>' + bdi(meta) + '</span></div>' +
          '<em>' + bdi(self.money(price)) + '</em></li>';
      }).join('');
      return '<article class="ckfp-incart__pack" aria-labelledby="' + this.uid + '-pk' + pi + '">' +
        '<div class="ckfp-incart__pack-head"><h3 id="' + this.uid + '-pk' + pi + '">' + (this.packs.length > 1 ? esc(fill(s.pack_n, { n: pi + 1 })) + ' · ' : '') + bdi(pk.design) + '</h3>' +
          '<span>' + esc(fill(s.members_n, { n: pk.pieces })) + ' · ' + bdi(this.money(pk.sub)) + '</span></div>' +
        status +
        '<ul class="ckfp-lines" role="list">' + lines + '</ul>' +
        '<div class="ckfp-incart__pack-actions">' +
          '<button type="button" class="ckfp-btn" data-ckfp-edit="' + esc(pk.id) + '">' + ICON.edit + '<span>' + esc(s.edit_pack) + '</span></button>' +
          '<button type="button" class="ckfp-btn ckfp-btn--danger" data-ckfp-remove="' + esc(pk.id) + '">' + ICON.trash + '<span>' + esc(s.remove) + '</span></button>' +
        '</div>' +
      '</article>';
    }
    renderCartBar() {
      var s = this.s, pk = this.packs[0] || { lines: [], pieces: 0, sub: 0 };
      var pieces = this.packs.reduce(function (n, p) { return n + p.pieces; }, 0);
      var thumbs = pk.lines.slice(0, 3).map(function (it) { return it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=80') + '" alt="" width="40" height="40">' : ''; }).join('');
      this.barEl.innerHTML =
        '<div class="ckfp-bar__row">' +
          '<span class="ckfp-bar__info">' +
            '<span class="ckfp-bar__thumbs">' + (thumbs || '<i>' + ICON.family + '</i>') + '<b>' + pieces + '</b></span>' +
            '<span class="ckfp-bar__txt"><strong>' + esc(s.in_cart) + '</strong><small>' + esc(fill(s.members_n, { n: pieces })) + '</small></span>' +
          '</span>' +
          '<a class="ckfp-bar__btn" href="' + esc(this.cfg.cartUrl) + '">' + esc(s.go_cart) + ICON.bag + '</a>' +
        '</div>';
      this.measureBar();
    }
    updateCart(keys) {
      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });
      return fetch(this.cfg.cartUpdateUrl || (this.cfg.cartUrl + '/update.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || ''); return d; }); });
    }
    broadcast(cart) {
      // header badge, cart drawer, bottom menu and the cart box follow the change
      this._ownUpdate = true;
      document.querySelectorAll('[data-js-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      this._ownUpdate = false;
    }
    removePack(id, btn) {
      var pk = this.packs.find(function (p) { return p.id === id; });
      if (!pk || this._removing) return;
      var self = this, s = this.s;
      this._removing = true;
      btn.disabled = true;
      btn.querySelector('span').textContent = s.removing;
      this.updateCart(pk.lines.map(function (it) { return it.key; })).then(function (c) {
        self._removing = false;
        if (self.editing && self.editing.id === id) self.setEditing(null);
        self.setCart(c);
        self.broadcast(c);
        self.toast(s.removed, true);
        var h = self.incartEl.querySelector('h2') || self.querySelector('.ckfp-step__title');
        if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      }).catch(function (err) {
        self._removing = false;
        self.toast(err && err.message ? err.message : s.error);
        self.loadCart();
      });
    }
    // put a pack from the cart back into the builder
    editPack(id) {
      var pk = this.packs.find(function (p) { return p.id === id; });
      if (!pk) return;
      var self = this, s = this.s, members = [], color = null, design = null;
      pk.lines.forEach(function (it) {
        var hit = self.byVariant[it.variant_id];
        if (!hit) return;
        var p = hit.p, v = hit.v, pr = it.properties || {};
        if (!design) design = designKey(p);
        if (!color && p.colorPos) color = norm(v.options[p.colorPos - 1]);
        var label = '';
        Object.keys(pr).forEach(function (k) { if (k.charAt(0) !== '_' && !label) label = String(pr[k]); });
        for (var q = 0; q < it.quantity; q++) {
          var m = self.newMember();
          m.size = v.options[p.sizePos - 1];
          if (p._adults.length && !p._kids.length) m.kind = p._kind;
          m.g = pr._fm_g === 'm' || pr._fm_g === 'f' ? pr._fm_g :
            (new RegExp('(' + [s.woman, s.girl, s.female].join('|') + ')').test(label) ? 'f' :
              new RegExp('(' + [s.man, s.boy, s.male].join('|') + ')').test(label) ? 'm' : null);
          var age = parseFloat(pr._fm_age);
          if (isNaN(age)) {
            var isKidSize = p._kids.some(function (z) { return z.name === m.size; });
            if (!isKidSize) age = self.adultAge;
            else {
              // older packs: read the age from the saved text ("Member 3 · Boy · 5 years")
              var hitAge = self.ageOptions().filter(function (o) { return o.v < self.adultAge && label.indexOf(o.label) > -1; })
                .sort(function (a, b) { return b.label.length - a.label.length; })[0];
              if (hitAge) { m.age = hitAge.v; members.push(m); continue; }
              var z = p._kids.find(function (x) { return x.name === m.size; });
              var opt = self.ageOptions().filter(function (o) { return o.v < self.adultAge && o.v >= z.info.min; })[0];
              age = opt ? opt.v : null;
            }
          }
          m.age = age;
          members.push(m);
        }
      });
      if (!members.length) return;
      while (members.length < this.min) members.push(this.newMember());
      this.members = members.slice(0, this.max);
      if (color && this.colors.some(function (c) { return c.key === color; })) this.color = color;
      if (design && this.byDesign[design]) this.design = design;
      this.showErrors = false;
      this.setEditing({ id: id, keys: pk.lines.map(function (it) { return it.key; }) });
      this._userChoseMode = true;
      this.mode = 'build';
      this.save();
      this.renderAll();
      this.renderMode();
      this.scrollToBuilder();
    }
    startNew() {
      this._userChoseMode = true;
      this.setEditing(null);
      this.mode = 'build';
      var n = this.cfg.defaultMembers || 4, target = Math.max(this.min, Math.min(this.max, n));
      this.members = [];
      while (this.members.length < target) this.members.push(this.newMember());
      this.color = this.colors.length === 1 ? this.colors[0].key : null;
      this.design = this.designs.length === 1 ? this.designs[0].key : null;
      this.showErrors = false;
      this.save();
      this.renderAll();
      this.renderMode();
      this.scrollToBuilder();
    }
    cancelEdit() {
      this.setEditing(null);
      store(this.cfg.storageKey, null);
      this._userChoseMode = false;
      this.mode = this.packs.length ? 'cart' : 'build';
      this.restore();
      this.renderAll();
      this.renderMode();
      var top = this.getBoundingClientRect().top + window.pageYOffset - this.headerOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    scrollToBuilder() {
      var target = this.incartEl.hidden ? this.querySelector('.ckfp__body') : this.incartEl;
      var top = target.getBoundingClientRect().top + window.pageYOffset - this.headerOffset();
      if (window.ckLenis && window.ckLenis.scrollTo) window.ckLenis.scrollTo(top, { immediate: true });
      else window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      var h = this.querySelector('.ckfp-step__title');
      if (h) { h.setAttribute('tabindex', '-1'); setTimeout(function () { h.focus({ preventScroll: true }); }, 80); }
    }

    toast(text, ok) {
      var el = this.toastEl;
      el.innerHTML = (ok ? ICON.check : ICON.alert) + '<span>' + esc(text) + '</span>';
      el.classList.add('is-open');
      clearTimeout(this._t);
      this._t = setTimeout(function () { el.classList.remove('is-open'); }, 2200);
    }

    /* ---------- keep clear of the store's bottom menu + floating app buttons ---------- */
    watchBottom() {
      var self = this;
      var update = function () { self.measureBar(); };
      window.addEventListener('resize', update);
      window.addEventListener('orientationchange', update);
      if (window.ResizeObserver) {
        var nav = document.querySelector('.ck-bottom-bar');
        var ro = new ResizeObserver(update);
        ro.observe(this.barEl);
        if (nav) ro.observe(nav);
      }
      [600, 2000, 5000].forEach(function (ms) { setTimeout(update, ms); });
    }
    measureBar() {
      var nav = document.querySelector('.ck-bottom-bar');
      var navH = 0;
      if (nav) {
        var cs = getComputedStyle(nav);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && cs.position === 'fixed') navH = nav.getBoundingClientRect().height;
      }
      var barVisible = getComputedStyle(this.barEl).display !== 'none';
      var barH = barVisible ? this.barEl.getBoundingClientRect().height : 0;
      [this, this.sheetEl, this.barEl, this.toastEl].forEach(function (el) {
        el.style.setProperty('--fp-nav-h', navH + 'px');
        el.style.setProperty('--fp-bar-h', barH + 'px');
      });
      this.liftFloating(barVisible ? barH : 0);
    }
    liftFloating(h) {
      var self = this;
      var found = document.querySelectorAll('[id*="whatsapp" i],[class*="whatsapp" i],[id*="wa-chat" i],[class*="wa-chat" i],[class*="wa_chat" i]');
      var fixed = Array.prototype.filter.call(found, function (el) {
        return !self.contains(el) && !self.barEl.contains(el) && !self.sheetEl.contains(el) && getComputedStyle(el).position === 'fixed';
      });
      fixed.forEach(function (el) {
        if (fixed.some(function (o) { return o !== el && o.contains(el); })) return;
        el.style.setProperty('transition', 'transform .3s ease');
        el.style.setProperty('transform', h ? 'translateY(-' + Math.round(h) + 'px)' : 'none', 'important');
      });
    }
  }

  customElements.define('ck-family-pack', CKFamilyPack);
})();